import { useEffect } from 'react'
import { FinancialAccount } from '@/reducers/finances/financialAccountsReducer'
import { FinancialAccountWithAdminInfo } from '@/reducers/admin/financialAccountsReducer'
import { useHeardPlaid } from './helpers'
import { logHeardError } from '@/utils/errorHelpers'

export const PlaidOauthLink = ({
  account = null,
  redirectLink,
  redirectUri,
}: {
  account?: FinancialAccount | FinancialAccountWithAdminInfo | null
  redirectLink: string
  redirectUri?: string
}) => {
  const linkToken = localStorage.getItem('link_token')

  if (!linkToken) {
    logHeardError('No link token for Plaid Oauth ')
  }

  const { open, ready, error } = useHeardPlaid({
    account,
    linkToken: linkToken || undefined,
    redirectLink,
    redirectUri,
    receivedRedirectUri: window.location.href,
  })

  // automatically re-initialize Link
  useEffect(() => {
    if (ready) {
      open()
    }
    if (error) {
      logHeardError(error.error)
    }
  }, [ready, open, error])

  return null
}
